/**
 * @fileoverview Mapeo y resolución automática de títulos de pestaña de navegador según la ruta activa.
 * @module utils/pageTitle
 */

export function getPageTitleByPath(
  pathname: string,
  t: (key: string, options?: any) => string
): string {
  const clean = pathname.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/';
  const SUFFIX = ' | Logrit';

  // Autenticación
  if (clean === '/signin') {
    return `${t('auth.signin', { defaultValue: 'Iniciar Sesión' })}${SUFFIX}`;
  }
  if (clean === '/signup') {
    return `${t('auth.signup', { defaultValue: 'Crear Cuenta' })}${SUFFIX}`;
  }
  if (clean === '/reset-password') {
    return `${t('auth.resetPassword', { defaultValue: 'Recuperar Contraseña' })}${SUFFIX}`;
  }

  // Onboarding
  if (clean.startsWith('/onboarding')) {
    return `${t('onboarding.title', { defaultValue: 'Configuración Familiar' })}${SUFFIX}`;
  }

  // Dashboards y vistas principales
  if (clean === '/groups/dashboard') {
    return `${t('common.tableropersonal', { defaultValue: 'Tablero' })}${SUFFIX}`;
  }
  if (clean === '/groups/home-groups') {
    return `${t('common.tablerogrupal', { defaultValue: 'Hogar Familiar' })}${SUFFIX}`;
  }
  if (clean === '/groups/board') {
    return `${t('navigation.board', { defaultValue: 'Pizarra Familiar' })}${SUFFIX}`;
  }
  if (clean.startsWith('/calendar') || clean.startsWith('/groups/calendar')) {
    return `${t('common.calendario', { defaultValue: 'Calendario' })}${SUFFIX}`;
  }

  // Hábitos, Rutinas y Tareas
  if (clean.startsWith('/groups/checklist') || clean.startsWith('/checklist')) {
    return `${t('common.tareas', { defaultValue: 'Hábitos & Tareas' })}${SUFFIX}`;
  }
  if (clean.startsWith('/groups/activities') || clean.startsWith('/actividades')) {
    return `${t('common.actividades', { defaultValue: 'Actividades' })}${SUFFIX}`;
  }
  if (clean.startsWith('/groups/routines') || clean.startsWith('/routines')) {
    return `${t('common.rutinas', { defaultValue: 'Rutinas' })}${SUFFIX}`;
  }
  if (clean.startsWith('/rewards')) {
    return `${t('common.recompensas', { defaultValue: 'Recompensas' })}${SUFFIX}`;
  }

  // Cocina & Alimentación
  if (clean.startsWith('/family/recipes') || clean.startsWith('/recipes')) {
    return `${t('family.recipes', { defaultValue: 'Recetas' })}${SUFFIX}`;
  }
  if (clean.startsWith('/family/meal-planner')) {
    return `${t('family.mealPlanner', { defaultValue: 'Planificador de Comidas' })}${SUFFIX}`;
  }
  if (clean.startsWith('/family/shopping-list')) {
    return `${t('family.shoppingList', { defaultValue: 'Lista de Compras' })}${SUFFIX}`;
  }

  // IA y Comunicación
  if (clean.startsWith('/ai-assistant')) {
    return `${t('features.gritiAI.sidebarLabel', { defaultValue: 'Asistente IA' })}${SUFFIX}`;
  }
  if (clean.startsWith('/calls')) {
    return `${t('calls.title', { defaultValue: 'Llamadas' })}${SUFFIX}`;
  }
  if (clean.startsWith('/communications')) {
    return `${t('communications.title', { defaultValue: 'Comunicaciones' })}${SUFFIX}`;
  }

  // Gestión de Familia y Miembros
  if (clean.startsWith('/groups/members')) {
    return `${t('common.members', { defaultValue: 'Miembros' })}${SUFFIX}`;
  }
  if (clean.startsWith('/groups/groups')) {
    return `${t('common.grupos', { defaultValue: 'Familia' })}${SUFFIX}`;
  }

  // Escuela / Educa
  if (clean.startsWith('/groups/subjects')) {
    return `${t('educa.subjects', { defaultValue: 'Materias' })}${SUFFIX}`;
  }
  if (clean.startsWith('/groups/evaluations') || clean.startsWith('/groups/my-grades')) {
    return `${t('educa.evaluations', { defaultValue: 'Evaluaciones' })}${SUFFIX}`;
  }
  if (clean.startsWith('/groups/attendance')) {
    return `${t('educa.attendance', { defaultValue: 'Asistencia' })}${SUFFIX}`;
  }
  if (clean.startsWith('/groups/reports')) {
    return `${t('educa.reports', { defaultValue: 'Reportes' })}${SUFFIX}`;
  }

  // Configuración y cuenta
  if (clean.startsWith('/settings/personalization') || clean === '/personalization') {
    return `${t('personalization.title', { defaultValue: 'Personalización' })}${SUFFIX}`;
  }
  if (clean.startsWith('/settings/data-management')) {
    return `${t('dataManagement.title', { defaultValue: 'Gestión de Datos' })}${SUFFIX}`;
  }
  if (clean === '/preferences') {
    return `${t('common.preferencias', { defaultValue: 'Preferencias' })}${SUFFIX}`;
  }
  if (clean === '/subscription' || clean === '/pricing') {
    return `${t('common.suscripcion', { defaultValue: 'Suscripción' })}${SUFFIX}`;
  }
  if (clean === '/notifications') {
    return `${t('common.notificaciones', { defaultValue: 'Notificaciones' })}${SUFFIX}`;
  }
  if (clean === '/referrals') {
    return `${t('referrals.title', { defaultValue: 'Referidos' })}${SUFFIX}`;
  }

  // Legal
  if (clean === '/terms' || clean === '/terms-and-conditions') {
    return `${t('legal.terms', { defaultValue: 'Términos y Condiciones' })}${SUFFIX}`;
  }
  if (clean === '/privacy' || clean === '/privacy-policy') {
    return `${t('legal.privacy', { defaultValue: 'Política de Privacidad' })}${SUFFIX}`;
  }

  // Título principal por defecto
  return 'Logrit - Organiza tu vida familiar';
}
